import './App.css';
import { useState,useRef, useEffect } from 'react';
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollSmoother } from 'gsap/ScrollSmoother'
import { useGSAP } from '@gsap/react'
import './i18n/config';

import Navbar from './components/NavBar/NavBar';
import About from './pages/About/About';
import Hero from './pages/Hero/Hero';
import Contact from './pages/Contact/Contact'
import ImpactScroller from './pages/Impact/ImpactScroller';
import Wear from './pages/Wear/Wear';
import Solutions from './pages/Solutions/Solutions';
import { useTranslation } from 'react-i18next';
import LogoCarousel from './components/LogoCarousel/LogoCarousel';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollSmoother);

function App() {
  const { t } = useTranslation(['common']);
  const [, selectPage] = useState(0);
  const containerRef = useRef();
  const [domReady, setDomReady] = useState(false);

  useEffect(() => {
    const checkState = () => {
      
      if (document.readyState === 'complete') {
        return;
      }
      
      // Seguir checkeando cada 50ms
      setTimeout(checkState, 5);
    };
    
    checkState();
  }, []);

    // dom loaded
    useEffect(() => {
      ScrollTrigger.refresh();
        const checkDOMReady = () => {
            const wear = document.querySelector('.section-hero');
            const impact = document.querySelector('.section-impact');
            
            if (wear && impact) {
                setDomReady(true);
                ScrollTrigger.refresh();
            } else {
                requestAnimationFrame(checkDOMReady);
            }
        };

        setTimeout(checkDOMReady, 50);
    }, []);

  useGSAP(() => {
  const ctx = gsap.context(() => {
    if (!domReady) return;
    
    // NO usar cleanup global - solo limpiar los específicos del hero
    
    let match = gsap.matchMedia();
    
    match.add("(min-width: 768px)", () => {
      // Limpiar solo ScrollSmoother si existe
      if (ScrollSmoother.get()) {
        ScrollSmoother.get().kill();
      }
      
      // eslint-disable-next-line
      let smoother = ScrollSmoother.create({
        wrapper: "#smooth-wrapper",
        content: "#smooth-content"
      });
      
      // Esperar a que ScrollSmoother esté listo
      gsap.delayedCall(0.3, () => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: ".section-hero",
            start: "top top",
            end: "+=500",
            scrub: true,
            pin: '.section-hero',
            pinSpacing: false,
            markers: false
          }
        });
        
        tl.to('.section-hero', {
          filter: 'blur(8px)'
        }, 0);
      });
    });
    
    match.add("(max-width: 767px)", () => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".section-hero",
          start: "top top",
          end: "+=300",
          scrub: true,
          pin: '.section-hero',
          pinSpacing: false,
          markers: false
        }
      });
      
      tl.to('.section-hero', {
        filter: 'blur(8px)'
      }, 0);
    });

    return () => {
      match.kill();
      // Solo limpiar ScrollSmoother, no todos los ScrollTriggers
      if (ScrollSmoother.get()) {
        ScrollSmoother.get().kill();
      }
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  });
  
  return () => ctx.revert();
}, { scope: containerRef, dependencies: [domReady] });

  return (
    <div id='smooth-wrapper' ref={containerRef} className='bg-bluekali-navy-blue'>
      <Navbar onSelect={(index) => {
          selectPage(index);
        }} />
      <div id='smooth-content'>
        <Hero className='section-hero'/>
        <div className='relative flex flex-col'>
          <div className="bg-bluekali-navy-blue h-10 w-full rounded-t-full z-20"/>
          <About className='section-about'/>
        </div>
        <div className="md:hidden flex flex-col w-full items-start bg-bluekali-white pl-6 md:px-4 py-6 md:rounded-lg">
          <p className="text-base mb-1 text-bluekali-cerulean-blue font-bold test-animation">{t('partners')}</p>
          <LogoCarousel/>        
        </div>
        <ImpactScroller/> 
        {/* <div className='section-impact' id='section-impact'>
          Sction wear
        </div> */}
        <div className='relative bg-gradient-to-b from-bluekali-white to-bluekali-tomato'>
          <Wear className='section-wear'/>
        </div>
        <Solutions className='section-solutions'/>
        <Contact className='section-contact'/>
      </div>
    </div>
  );
}

export default App;
